// @ts-nocheck

import * as BadgeAssets from '../assets/img/badges';
import * as BadgeDetailsAssets from '../assets/img/badges/details';
import * as BannerAssets from '../assets/img/banners';
import * as AnimatedBannerAssets from '../assets/img/banners/animated';
import * as StepAssets from '../assets/img/steps';
import { KLBannerStates } from '../types/banner';
import { KLCollectibleIds } from '../types/collectible';

export const KLBadgeAssetByBadgeId = {
  // Round 1
  [KLCollectibleIds.FISHING]: {
    default: BadgeAssets.KLFishingBadge,
    pending: BadgeAssets.KLFishingBadgePending,
    won: BadgeAssets.KLFishingBadgeWon,
  },
  [KLCollectibleIds.GRAND_BLUE]: {
    default: BadgeAssets.KLGrandBlueBadge,
    pending: BadgeAssets.KLGrandBlueBadgePending,
    won: BadgeAssets.KLGrandBlueBadgeWon,
  },
  [KLCollectibleIds.FIRECAMP]: {
    default: BadgeAssets.KLFireBadge,
    pending: BadgeAssets.KLFireBadgePending,
    won: BadgeAssets.KLFireBadgeWon,
  },
  [KLCollectibleIds.BALANCE]: {
    default: BadgeAssets.KLBalanceBadge,
    pending: BadgeAssets.KLBalanceBadgePending,
    won: BadgeAssets.KLBalanceBadgeWon,
  },
  [KLCollectibleIds.HUT]: {
    default: BadgeAssets.KLHutBadge,
    pending: BadgeAssets.KLHutBadgePending,
    won: BadgeAssets.KLHutBadgeWon,
  },
  [KLCollectibleIds.RICE]: {
    default: BadgeAssets.KLRiceBadge,
    pending: BadgeAssets.KLRiceBadgePending,
    won: BadgeAssets.KLRiceBadgeWon,
  },
  [KLCollectibleIds.WATER]: {
    default: BadgeAssets.KLWaterBadge,
    pending: BadgeAssets.KLWaterBadgePending,
    won: BadgeAssets.KLWaterBadgeWon,
  },

  // Round 2
  [KLCollectibleIds.DUO]: {
    default: BadgeAssets.KLDuoBadge,
    pending: BadgeAssets.KLDuoBadgePending,
    won: BadgeAssets.KLDuoBadgeWon,
  },
  [KLCollectibleIds.SLOTH]: {
    default: BadgeAssets.KLSlothBadge,
    pending: BadgeAssets.KLSlothBadgePending,
    won: BadgeAssets.KLSlothBadgeWon,
  },
  [KLCollectibleIds.BAMBOOS]: {
    default: BadgeAssets.KLBamboosBadge,
    pending: BadgeAssets.KLBamboosBadgePending,
    won: BadgeAssets.KLBamboosBadgeWon,
  },
};

export const KLBadgeDetailsAssetByBadgeId = {
  // Round 1
  [KLCollectibleIds.FISHING]: {
    default: BadgeDetailsAssets.KLFishingBadgeDetails,
    pending: BadgeDetailsAssets.KLFishingBadgeDetailsPending,
    won: BadgeDetailsAssets.KLFishingBadgeDetailsWon,
  },
  [KLCollectibleIds.GRAND_BLUE]: {
    default: BadgeDetailsAssets.KLGrandBlueBadgeDetails,
    pending: BadgeDetailsAssets.KLGrandBlueBadgeDetailsPending,
    won: BadgeDetailsAssets.KLGrandBlueBadgeDetailsWon,
  },
  [KLCollectibleIds.FIRECAMP]: {
    default: BadgeDetailsAssets.KLFireBadgeDetails,
    pending: BadgeDetailsAssets.KLFireBadgeDetailsPending,
    won: BadgeDetailsAssets.KLFireBadgeDetailsWon,
  },
  [KLCollectibleIds.BALANCE]: {
    default: BadgeDetailsAssets.KLBalanceBadgeDetails,
    pending: BadgeDetailsAssets.KLBalanceBadgeDetailsPending,
    won: BadgeDetailsAssets.KLBalanceBadgeDetailsWon,
  },
  [KLCollectibleIds.HUT]: {
    default: BadgeDetailsAssets.KLHutBadgeDetails,
    pending: BadgeDetailsAssets.KLHutBadgeDetailsPending,
    won: BadgeDetailsAssets.KLHutBadgeDetailsWon,
  },
  [KLCollectibleIds.RICE]: {
    default: BadgeDetailsAssets.KLRiceBadgeDetails,
    pending: BadgeDetailsAssets.KLRiceBadgeDetailsPending,
    won: BadgeDetailsAssets.KLRiceBadgeDetailsWon,
  },
  [KLCollectibleIds.WATER]: {
    default: BadgeDetailsAssets.KLWaterBadgeDetails,
    pending: BadgeDetailsAssets.KLWaterBadgeDetailsPending,
    won: BadgeDetailsAssets.KLWaterBadgeDetailsWon,
  },

  // Round 2
  [KLCollectibleIds.DUO]: {
    default: BadgeDetailsAssets.KLDuoBadgeDetails,
    pending: BadgeDetailsAssets.KLDuoBadgeDetailsPending,
    won: BadgeDetailsAssets.KLDuoBadgeDetailsWon,
  },
  [KLCollectibleIds.SLOTH]: {
    default: BadgeDetailsAssets.KLSlothBadgeDetails,
    pending: BadgeDetailsAssets.KLSlothBadgeDetailsPending,
    won: BadgeDetailsAssets.KLSlothBadgeDetailsWon,
  },
  [KLCollectibleIds.BAMBOOS]: {
    default: BadgeDetailsAssets.KLBamboosBadgeDetails,
    pending: BadgeDetailsAssets.KLBamboosBadgeDetailsPending,
    won: BadgeDetailsAssets.KLBamboosBadgeDetailsWon,
  },
};

export const KLRound3StepAssetByCollectibleId = {
  [KLCollectibleIds.MARK]: [StepAssets.KLLandmark1, StepAssets.KLLandmark2, StepAssets.KLLandmark3],
  [KLCollectibleIds.TAG]: [StepAssets.KLTag1, StepAssets.KLTag2, StepAssets.KLTag3],
  [KLCollectibleIds.KNIFE]: [StepAssets.KLKnife1, StepAssets.KLKnife2, StepAssets.KLKnife3],
};

export const KLRound3PathAssetByTryIndex = [StepAssets.KLPath1, StepAssets.KLPath2, StepAssets.KLPath3];

export const KLBannerStaticBackgroundPathByBannerStates = {
  [KLBannerStates.TEASER]: BannerAssets.KLTeaserBanner,
  [KLBannerStates.START]: BannerAssets.KLTeaserBanner,
  [KLBannerStates.ELIMINATED]: BannerAssets.KLTeaserBanner,
  [KLBannerStates.T_RED]: BannerAssets.KLRedTribeBanner,
  [KLBannerStates.T_WHITE]: BannerAssets.KLWhiteTribeBanner,
  [KLBannerStates.ORIENTATION]: BannerAssets.KLOrientationBanner,
  [KLBannerStates.POLE]: BannerAssets.KLPoleBanner,
  [KLBannerStates.ENDING]: BannerAssets.KLEndingBanner,
};

export const KLBannerAnimatedBackgroundPathByBannerStates = {
  [KLBannerStates.START]: AnimatedBannerAssets.KLStartAnimatedBanner,
  [KLBannerStates.T_RED]: AnimatedBannerAssets.KLResumeRedTribeAnimatedBanner,
  [KLBannerStates.T_WHITE]: AnimatedBannerAssets.KLResumeWhiteTribeAnimatedBanner,
  [KLBannerStates.ORIENTATION]: AnimatedBannerAssets.KLResumeOrientationAnimatedBanner,
  [KLBannerStates.POLE]: AnimatedBannerAssets.KLResumePoleAnimatedBanner,
};

export const KLBannerAnimatedBackgroundPathFallbackByBannerStates = new Proxy(
  {
    [KLBannerStates.START]: BannerAssets.KLStartBanner,
    [KLBannerStates.T_RED]: BannerAssets.KLResumeRedTribeBanner,
    [KLBannerStates.T_WHITE]: BannerAssets.KLResumeWhiteTribeBanner,
    [KLBannerStates.ORIENTATION]: BannerAssets.KLResumeOrientationBanner,
    [KLBannerStates.POLE]: BannerAssets.KLResumePoleBanner,
  },
  {
    get(origin, key) {
      return origin[key] ?? BannerAssets.KLStartBanner;
    },
  },
);
